import React from 'react';
import { HSLColor, hslToHex } from '../utils/colorUtils';
import { Check, Star } from 'lucide-react';
interface ColorSwatchProps {
  color: HSLColor;
  isSelected: boolean;
  onSelect: (color: HSLColor) => void;
  baseColor?: HSLColor;
}
export function ColorSwatch({
  color,
  isSelected,
  onSelect,
  baseColor
}: ColorSwatchProps) {
  const {
    h,
    s,
    l
  } = color;
  const hex = hslToHex(h, s, l);
  // Check if this swatch matches the current base color
  const isBaseColor = baseColor ? h === baseColor.h && s === baseColor.s && l === baseColor.l : false;
  return <button onClick={() => onSelect(color)} className={`
        group relative w-full aspect-square rounded-md transition-all duration-200
        hover:scale-105 hover:z-10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary/50
        ${isSelected ? 'scale-110 z-20 shadow-xl shadow-black/50' : ''}
        ${isBaseColor && !isSelected ? 'ring-2 ring-primary ring-offset-1 ring-offset-background z-10' : ''}
      `} style={{
    backgroundColor: `hsl(${h}, ${s}%, ${l}%)`
  }} aria-label={`Select color HSL(${h}, ${s}%, ${l}%)${isBaseColor ? ' (base color)' : ''}`} data-id="element-181">
      {/* Base Color Marker - small star icon */}
      {isBaseColor && !isSelected && <div className="absolute -top-1 -right-1 w-4 h-4 rounded-full bg-primary flex items-center justify-center shadow-sm" data-id="element-182">
          <Star className="w-2.5 h-2.5 text-primary-foreground fill-current" data-id="element-183" />
        </div>}

      {/* Selected Indicator */}
      {isSelected && <div className="absolute inset-0 flex items-center justify-center text-black" data-id="element-184">
          <Check className="w-6 h-6 drop-shadow-md" strokeWidth={3} data-id="element-185" />
        </div>}

      {/* Tooltip */}
      <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 px-2 py-1 bg-popover text-popover-foreground text-xs rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none whitespace-nowrap z-50 border border-[hsl(var(--border)/0.2)]" data-id="element-186">
        <div className="font-mono flex items-center gap-1.5" data-id="element-187">
          {hex}
          {isBaseColor && <span className="text-primary text-[10px]" data-id="element-188">★ BASE</span>}
        </div>
        <div className="text-[10px] text-muted-foreground" data-id="element-189">
          H:{h}° S:{s}% L:{l}%
        </div>
      </div>
    </button>;
}